import { AccountTransactionList } from "../tlSalesOnAccount";

const TLCashReceipts = () => <AccountTransactionList
  title="Cash Receipts"
  moduleId="ACTCRP"
  storageKey="cashReceipts.filters"
  accessPath="/api/cash-receipts/access"
  statusPath="/api/cash-receipts/status"
  printPath="/api/cash-receipts/print"
  transactionPath="/App/CashReceiptTransaction"
  setBranchPath="/api/cash-receipts/assignment"
  linkProjectPath="/api/cash-receipts/assignment"
  summaryPath="/api/cash-receipts/summary"
  documentPrefix="CR"
  rowClassPrefix="cr"
  moneyFields={["TotalReceipts", "TotalAppliedAR", "TotalInvoiced"]}
  centeredErrors
  hideUnauthorizedActions
/>;

export default TLCashReceipts;
